import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';

const EventTrackingContext = createContext({
  handleEvent: () => {
    throw new Error(
      "EventTrackingContext().trackEvent() has not been implemented. Did you forget to wrap your render tree with a EventTrackingProvider?"
    );
  }
});
function makeEventTrackingProvider(args) {
  return function EventTrackingWrapper(props) {
    return /* @__PURE__ */ jsx(EventTrackingContext.Provider, { value: args, children: props.children });
  };
}

export { EventTrackingContext, makeEventTrackingProvider };
//# sourceMappingURL=_provider.js.map
